// =====================================================================
// WeddingOS – src/services/locations.js
// =====================================================================
import { supabase } from "./supabase";

// Öffentliches Verzeichnis: aktive Partner-Locations (empty-safe).
export async function publicLocations() {
  const { data, error } = await supabase.rpc("public_locations");
  if (error) throw error;
  return data ?? [];
}

export async function submitLocationLead({ name, locationName, email, message, affiliateRef }) {
  const { data, error } = await supabase.functions.invoke("location-lead", {
    body: { name, location_name: locationName, email, message, affiliate_ref: affiliateRef ?? null },
  });
  if (error) throw error;
  return data;
}

export async function locationMe() {
  const { data, error } = await supabase.rpc("location_me");
  if (error) throw error;
  return data;
}

// Self-Service: eigenen Listing-Datensatz anlegen (owner = auth.uid()).
export async function createMyLocation({ locationName, contactName, region }) {
  const { data, error } = await supabase.rpc("create_my_location", {
    p_location_name: locationName, p_contact_name: contactName ?? null, p_region: region ?? null,
  });
  if (error) throw error;
  return data;
}

// Eigenes Verzeichnis-Listing bearbeiten (owner-geschützt).
export async function locationUpdateSelf({ name, description, region, website }) {
  const { data, error } = await supabase.rpc("location_update_self", {
    p_name: name, p_description: description ?? null, p_region: region ?? null, p_website: website ?? null,
  });
  if (error) throw error;
  return data;
}

export async function locationGenerateCode() {
  const { data, error } = await supabase.rpc("location_generate_code");
  if (error) throw error;
  return data;
}

export async function locationMyCodes() {
  const { data, error } = await supabase.rpc("location_my_codes");
  if (error) throw error;
  return data ?? [];
}

export async function redeemLocationCode({ code, weddingId }) {
  const { data, error } = await supabase.rpc("redeem_location_code", { p_code: code, p_wedding_id: weddingId });
  if (error) throw error;
  return data;
}

export async function weddingLocationBranding(weddingId) {
  const { data, error } = await supabase.rpc("wedding_location_branding", { p_wedding_id: weddingId });
  if (error) throw error;
  return data;
}

export async function adminLocationLeads() {
  const { data, error } = await supabase.rpc("admin_location_leads");
  if (error) throw error;
  return data ?? [];
}

export async function adminLocations() {
  const { data, error } = await supabase.rpc("admin_locations");
  if (error) throw error;
  return data ?? [];
}

export async function adminSetLocationStripe({ locationId, plan, priceCents, customerId, subscriptionId, affiliateRef }) {
  const { data, error } = await supabase.rpc("admin_set_location_stripe", {
    p_location_id: locationId, p_plan: plan, p_price_cents: priceCents,
    p_customer_id: customerId, p_subscription_id: subscriptionId, p_affiliate_ref: affiliateRef ?? null,
  });
  if (error) throw error;
  return data;
}

// Logo in public Bucket location-logos hochladen, gibt public URL zurück
export async function uploadLocationLogo({ locationId, file }) {
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "png";
  const path = `${locationId}/logo_${Date.now()}.${ext}`;
  const { error: upErr } = await supabase.storage.from("location-logos")
    .upload(path, file, { cacheControl: "3600", upsert: true });
  if (upErr) throw upErr;
  const { data } = supabase.storage.from("location-logos").getPublicUrl(path);
  const { error: updErr } = await supabase.from("locations").update({ logo_url: data.publicUrl })
    .eq("id", locationId);
  if (updErr) throw updErr;
  return data.publicUrl;
}
